import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, ConexaLogo } from '@conexasaude/conexa-hero'
import logoConexa from '@/assets/logo-conexa.svg'
import useStyles from './styles'
import { LightHeaderProps } from './types'

const LightHeader: FunctionComponent<LightHeaderProps> = ({
  uniqueCode,
  redirectTo,
  hiddenButton,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const goToLink = () => {
    history.push(redirectTo)
  }

  return (
    <div css={styles.container}>
      <div>
        <div css={styles.containerLogo}>
          {uniqueCode && uniqueCode.toLocaleLowerCase() !== 'conexa' ? (
            <img
              src={`${import.meta.env.VITE_APP_LINK_LOGO_AWS}${uniqueCode}.png`}
              onError={event => {
                event.currentTarget.onerror = null
                event.currentTarget.src = logoConexa
                event.currentTarget.style.height = 'auto'
              }}
              height="40px"
              alt="Conexa Saúde"
            />
          ) : (
            <ConexaLogo base="colorful" width={130} height={48} />
          )}
          {hiddenButton || (
            <Button variant="secondary" onClick={goToLink}>
              Voltar para o início
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export { LightHeader }
